export default "/images/1bb3b470bd0b12c54761ddb4acd24891.avif";